<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t("add") }} {{ $t("comment") }}</div>
      <router-link class="btn-blue" :to="{ name: 'Schedule Comments' }"
        >{{ $t("comments") }} {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="comment_name"
                name="comment_name"
                v-validate="'required'"
                v-model="comment_name"
                placeholder="."
              />
              <label>{{ $t("comment_name") }}</label>
            </div>
            <Tooltip :title="$t('comment_name')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('comment_name')">{{
              errors.first("comment_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="comment_description"
                name="comment_description"
                v-validate="'required'"
                v-model="comment_description"
                placeholder="Description"
              />
              <label>{{ $t("comment_description") }}</label>
            </div>
            <Tooltip :title="$t('comment_description')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('comment_description')">{{
              errors.first("comment_description")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <label class="ios-switch">
              <input
                type="checkbox"
                class="ios-checkbox"
                v-model="comment_is_active"
              />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button @click.prevent.stop="addComment()" class="btn-blue">
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      comment_name: "",
      comment_description: "",
      comment_is_active: true
    };
  },
  methods: {
    addComment() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // let loader = this.$loading.show();

          // console.log("JSON.stringify :", JSON.stringify(finalObj));
          let payload = {
            comment_name: this.comment_name,
            comment_description: this.comment_description,
            comment_is_active: this.comment_is_active
          };
          MasterService.AddComment(payload)
            .then(response => {
              const { data } = response;
              // loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/master/schedule-comments-master"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        } else {
          this.$toasted.show("Please enter all details");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/commentComponent/addComment.vue